import PropTypes from 'prop-types';
import React from 'react';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import InlineOverlayCloseButton from 'app/components/shared/InlineOverlay/InlineOverlayCloseButton';

const InlineOverlayHeader = ({ title, children }) => (
  <div className="content-header">
    <InlineOverlayCloseButton className="close-top-right">
      <span aria-hidden="true">&times;</span>
      <ScreenReaderMessage>Close</ScreenReaderMessage>
    </InlineOverlayCloseButton>
    {title || children ? <h4 className="content-title">{title || children}</h4> : null}
  </div>
);

InlineOverlayHeader.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

InlineOverlayHeader.displayName = 'InlineOverlayHeader';

export default InlineOverlayHeader;
